import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { ArrowRight, ChevronLeft, ChevronRight } from "lucide-react";
import { heroSlides } from "../mock";

const Hero = () => {
  const [active, setActive] = useState(0);

  useEffect(() => {
    const id = setInterval(() => {
      setActive((p) => (p + 1) % heroSlides.length);
    }, 6500);
    return () => clearInterval(id);
  }, []);

  const slide = heroSlides[active];

  return (
    <section className="relative w-full overflow-hidden bg-[#0B2545]">
      <div className="relative h-[560px] md:h-[640px]">
        {heroSlides.map((s, i) => (
          <div
            key={s.id}
            className={`absolute inset-0 transition-opacity duration-1000 ${
              i === active ? "opacity-100" : "opacity-0 pointer-events-none"
            }`}
          >
            <img
              src={s.image}
              alt={s.title}
              className="absolute inset-0 w-full h-full object-cover"
              loading={i === 0 ? "eager" : "lazy"}
            />
            <div className="absolute inset-0 bg-gradient-to-r from-[#0B2545]/90 via-[#0B2545]/70 to-transparent" />
          </div>
        ))}

        <div className="relative max-w-[1400px] mx-auto px-6 h-full flex items-center">
          <div className="max-w-2xl text-white">
            <div className="inline-flex items-center gap-2 bg-[#00A859] px-3.5 py-1.5 rounded-full text-xs font-bold uppercase tracking-wider mb-6 shadow-lg">
              <span className="w-1.5 h-1.5 rounded-full bg-white animate-pulse" />
              {slide.eyebrow}
            </div>
            <h1 className="text-4xl md:text-6xl font-extrabold leading-[1.05] mb-4 tracking-tight">
              {slide.title}
            </h1>
            <p className="text-xl md:text-2xl font-light text-gray-200 mb-5">
              {slide.subtitle}
            </p>
            <p className="text-base text-gray-300 max-w-xl mb-9 leading-relaxed">
              {slide.description}
            </p>
            <div className="flex flex-wrap gap-4">
              <Link
                to={slide.ctaLink}
                className="group inline-flex items-center gap-2 bg-[#00A859] hover:bg-[#00874A] text-white font-bold px-7 py-4 rounded-full text-sm uppercase tracking-wider transition-all hover:shadow-xl hover:shadow-[#00A859]/30"
              >
                {slide.cta}
                <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" />
              </Link>
              <Link
                to="/contatti"
                className="inline-flex items-center gap-2 border-2 border-white/30 hover:border-white text-white font-bold px-7 py-4 rounded-full text-sm uppercase tracking-wider transition-all backdrop-blur-sm"
              >
                Contattaci
              </Link>
            </div>
          </div>
        </div>

        {/* Controls */}
        <button
          onClick={() => setActive((p) => (p - 1 + heroSlides.length) % heroSlides.length)}
          className="absolute left-4 top-1/2 -translate-y-1/2 w-11 h-11 rounded-full bg-white/10 hover:bg-white/20 backdrop-blur-md text-white flex items-center justify-center transition-all hidden md:flex"
          aria-label="Slide precedente"
        >
          <ChevronLeft className="w-5 h-5" />
        </button>
        <button
          onClick={() => setActive((p) => (p + 1) % heroSlides.length)}
          className="absolute right-4 top-1/2 -translate-y-1/2 w-11 h-11 rounded-full bg-white/10 hover:bg-white/20 backdrop-blur-md text-white flex items-center justify-center transition-all hidden md:flex"
          aria-label="Slide successiva"
        >
          <ChevronRight className="w-5 h-5" />
        </button>

        {/* Dots */}
        <div className="absolute bottom-8 left-1/2 -translate-x-1/2 flex gap-2">
          {heroSlides.map((_, i) => (
            <button
              key={i}
              onClick={() => setActive(i)}
              className={`h-1.5 rounded-full transition-all ${
                i === active ? "w-10 bg-[#00A859]" : "w-2.5 bg-white/40 hover:bg-white/70"
              }`}
              aria-label={`Vai allo slide ${i + 1}`}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default Hero;
